import { Outlet, createFileRoute } from "@tanstack/react-router";

import { ProductLogoMediumDevices as LogoDevices } from "@/components/Logo";
import type { TabWithIndicatorProps } from "@/components/Navigation/HeaderTabs";
import { ProductHeader } from "@/components/ProductHeader";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import { useTranslation } from "@/lib/i18n";

export const Route = createFileRoute("/_staff/devices/_list")({
  component: DevicesLayout,
});

function DevicesLayout() {
  const { t } = useTranslation();
  useDocumentTitle(t("pages.devices.title"));

  const tabs = [
    {
      to: "/devices",
      children: t("common.list.overview"),
      activeOptions: { exact: true },
    },
    { to: "/devices/inventory", children: t("common.list.inventory") },
    { to: "/devices/people", children: t("common.list.people") },
    { to: "/devices/alerts", children: t("common.list.alerts") },
    { to: "/devices/catalog", children: t("common.list.catalog") },
    {
      to: "/devices/contract-and-cost",
      children: t("common.list.contractAndCost"),
    },
    {
      to: "/devices/operation-activity",
      children: t("common.list.operationActivity"),
    },
    {
      // NOTE:タブナビゲーションだが、 MarketPlaceは独立したプロダクト(apps,devicesの粒度)として扱われるためRouteが異なる
      to: "/marketplace/store/devices",
      children: t("common.list.marketplace"),
      target: "_blank",
    },
    {
      to: "/devices/rule-and-policy",
      children: t("common.list.ruleAndPolicy"),
    },
    { to: "/devices/settings", children: t("common.list.settings") },
  ] satisfies TabWithIndicatorProps[];

  return (
    <div className="flex flex-col">
      <ProductHeader
        Logo={LogoDevices}
        name={t("pages.devices.title")}
        tabs={tabs}
        type="resource"
      />
      <Outlet />
    </div>
  );
}
